import React from "react";
class AutoNumberingView extends React.Component {
  render() {
    // console.log("props data",this.props);
    const { shortDescription, longDescription } = this.props.user;
    return (
      <>
        <div className="row">
          <div className="col-md-11">
            <h1 className="heading m-b-25">
              Auto Numbering -#{this.props.user.Id}
            </h1>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            {/* Form Section start */}
            <div className="box-card">
              <div className="row">
                <div className="col-md-6" />
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>TRANSACTION TYPE</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={shortDescription}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>DESCRIPTION</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={longDescription}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* Form Section End */}
          </div>
        </div>
      </>
    );
  }
}

export default AutoNumberingView;
